var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"btn-wrapper flex-center",class:[_vm.inPopup ? 'popup' : 'page']},[_vm._l((_vm.configData),function(data){return [_c('Btn',_vm._b({key:data.key,attrs:{"loading":_vm.loading,"remainingShots":_vm.remainingShots,"upperLimitCount":_vm.upperLimitCount},on:{"clickHandler":_vm.clickHandler}},'Btn',data,false))]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }